import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { MarqueeRibbon } from "@/components/MarqueeRibbon";
import { Manifesto } from "@/components/Manifesto";
import { Portfolio } from "@/components/Portfolio";
import { BeforeAfterSection } from "@/components/BeforeAfterSection";
import { VideoSection } from "@/components/VideoSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { Seo } from "@/components/Seo";
import { useLang } from "@/i18n";

export default function Home() {
  const location = useLocation();
  const { t, lang } = useLang();

  useEffect(() => {
    if (!location.hash) return;
    const timer = setTimeout(() => {
      const el = document.querySelector(location.hash);
      if (el) window.__lenis ? window.__lenis.scrollTo(el) : el.scrollIntoView({ behavior: "smooth" });
    }, 500);
    return () => clearTimeout(timer);
  }, [location.hash]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <main className="grain-overlay bg-[#0A0A0C] text-zinc-100 antialiased overflow-x-clip">
      <Seo title={t("seo_home_title")} description={t("seo_home_desc")} path="/" lang={lang} />
      <Navbar />
      <Hero />
      <MarqueeRibbon />
      <Manifesto />
      <Portfolio />
      <BeforeAfterSection />
      <VideoSection />
      <ContactSection />
      <Footer />
    </main>
  );
}
